import { render, staticRenderFns } from "./WorkerTerms.vue?vue&type=template&id=0c2dbef4&scoped=true&"
import script from "./WorkerTerms.vue?vue&type=script&lang=js&"
export * from "./WorkerTerms.vue?vue&type=script&lang=js&"
import style0 from "./WorkerTerms.vue?vue&type=style&index=0&id=0c2dbef4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2dbef4",
  null
  
)

export default component.exports